import React from "react";
import { useHistory } from "react-router-dom";
import * as Path from "routes/paths";
import { IMG_LOGO_1, MAIN_LOGO_DUMMY_ } from "utils/constant";
import ReactPagination from "components/shared/ReactPagination";
import { itemsPerPage, PAGE_LIMIT_TRADE } from "helpers/viewContent";
import { DATE_FORMAT_TIME_ } from "helpers/common";

export default ({
  logData,
  setFilter,
  filter,
  totalCount
}) => {
  const history = useHistory();
  //pagination
  const handlePageChange = (page) => {
    setFilter({
      ...filter,
      page: page,
    });
    window.scrollTo(0, 0);
  };

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="card graph_card">
          <div className="card-body">
            <h4 className="card-title sidebar_title">Api Logs</h4>
            <div class="table-responsive">
              <table className="table common_tabel_th">
                <thead>
                  <tr>
                    <th> METHOD </th>
                    <th> PATH </th>
                    <th> DESCRIPTION </th>
                    <th> SOURCE IP</th>
                    <th> STATUS </th>
                    <th> TIMESTAMP </th>
                    <th> DURATION </th>
                  </tr>
                </thead>
                <tbody>
                  {logData?.length > 0 ?
                    logData.map((list, i) => {
                      return (
                        <tr
                          title="view"
                          className="cursor-pointer"
                        >
                          <td className="d-flex align-items-center">
                            {list.method ? list?.method : "N/A"}
                          </td>
                          <td>{list.endpoint ? list.endpoint?.replace("/api/v1/tradingApis", "") : "N/A"}</td>
                          <td>{list.message ? list?.message : "N/A"}</td>
                          <td>{list.ip ? list?.ip : "N/A"}</td>
                          <td>
                            <label
                              className={`badge ${list?.statusCode === 200 ? "badge-success" : "badge-danger"
                                }`}
                            >
                              {list?.statusCode ?? "N/A"}
                            </label>
                          </td>
                          <td>{DATE_FORMAT_TIME_(list?.createdAt)}</td>
                          <td>{list.responseTimeMs ? `${list?.responseTimeMs} Ms` : "N/A"}</td>
                        </tr>
                      );
                    }) :
                    <tr>
                      <td colSpan={7} className="text-center">
                        No Data Found
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
            {logData?.length > 0 && (
              <div className="pagination-box-review">
                <ReactPagination
                  activePage={filter?.page}
                  itemsCountPerPage={filter?.limit}
                  totalItemsCount={totalCount}
                  handlePageChange={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
